/**
 * Returns a list of filter values based on the user selection
 *
 * @param newValue - Value being selected or unselected
 * @param selectedValues - Values previously selected
 */
export const updateMultiselectFilter = ({
  newValue,
  selectedValues,
  isSingleSelect,
}: {
  selectedValues: string[]
  newValue: string
  isSingleSelect?: boolean
}): string[] => {
  /**
   * Rules for radio buttons
   * It won't ever deselect - just replace the value
   */
  if (isSingleSelect) {
    return [newValue]
  }

  const isSelecting = !selectedValues.includes(newValue)

  // Append new value if never selected
  if (isSelecting) {
    return [...selectedValues, newValue]
  }

  //   Remove value if it was already selected
  return selectedValues.filter((item) => item !== newValue)
}
